import { AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';
import logo from '@/assets/logo.png';

const MaintenancePage = () => (
  <div className="min-h-screen bg-background flex items-center justify-center px-4">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center max-w-md"
    >
      <img src={logo} alt="FixEveryday" className="h-16 w-16 mx-auto mb-6 rounded-full" />
      <div className="h-16 w-16 rounded-full bg-warning/10 flex items-center justify-center mx-auto mb-6">
        <AlertTriangle className="h-8 w-8 text-warning" />
      </div>
      <h1 className="text-2xl font-bold mb-3">We'll Be Back Soon!</h1>
      <p className="text-muted-foreground mb-2">
        We're currently performing maintenance to improve your experience.
      </p>
      <p className="text-sm text-muted-foreground">
        Due to a technical issue, our services are temporarily unavailable. Please check back shortly.
      </p>
      <div className="mt-8 flex items-center justify-center gap-2 text-xs text-muted-foreground">
        <div className="h-2 w-2 rounded-full bg-warning animate-pulse" />
        Maintenance in progress
      </div>
    </motion.div>
  </div>
);

export default MaintenancePage;
